// extracted by mini-css-extract-plugin
module.exports = {"clockHook":"ClockHook_clockHook__2YltQ","pTitle":"ClockHook_pTitle__26Ru9","pClock":"ClockHook_pClock__34hA3"};